module.exports = __webpack_public_path__ + "img/garantie-optique.dd6ec3fe.svg";